<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center">Sets de Productos</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <v-card flat>
        <PlusMenu :default-action="viewDialog" />

        <v-card-text>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details
            class="mb-4"></v-text-field>
          <v-data-table :headers="headers" :items="movements" :search="search" class="elevation-1 custom-font">
            <template v-slot:[`item.costCenter`]="{ item }">
              {{ item.costCenter === "All" ? "Todos" : item.costCenter }}
            </template>
            <template v-slot:[`item.active`]="{ item }">
              <v-chip :color="item.active ? 'success' : 'error'" dark>
                {{ item.active ? "Activo" : "Inactivo" }}
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
              </v-icon>
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              No hay items
            </template>
          </v-data-table>
        </v-card-text>

      </v-card>
    </v-card>

    <v-dialog v-model="gestRequest" max-width="1000px" :key="keyStock">
      <kits :kit="kitId" v-on="{ saveStock, closeModal }" />
    </v-dialog>

    <v-dialog v-model="getKitView" max-width="1000px" :key="keyView">
      <kitsView :kit="kitId" v-on="{ closeModal, cloneKit }" />
    </v-dialog>

    <v-dialog v-model="getKitClone" max-width="1000px" :key="keyView">
      <kitsClone :kit="cloneKitId" v-on="{ closeModal, saveStock }" />
    </v-dialog>
  </div>

</template>
<script>
import axios from "axios";
import api from "../../conf/ruta-base";
import UserProfile from "../../data";
import viewEmployee from "./view.vue";
import PlusMenu from "../../components/plusMenu.vue"
import clientHttp from "../../tools/clientHttp";
import kits from "./kits.vue";
import kitsClone from "./kitsClone.vue";
import kitsView from '../../components/kitsView.vue'
import { getKitsCache, saveKits } from '../../dataApi'
export default {
  components: {
    viewEmployee, PlusMenu,
    kits, kitsView, kitsClone
  },
  data: () => ({
    dataForm: {},
    disabledForm: false,
    user: UserProfile.getUserData(),
    search: "",
    tituloDialogo: "Nuevo Movimiento",
    dialog: false,
    crateEditVer: false,
    dialogDelete: false,
    gestRequest: false,
    movements: [],
    headers: [

      { text: "ID", value: "id" },
      { text: "REFERENCIA", value: "ref" },
      { text: "CENTRO DE COSTOS", value: "costCenter" },
      { text: "ZONA", value: "zone" },
      { text: "CARGOS", value: "positions" },
      { text: "ESTADO", value: "active" },
      { text: "Acciones", value: "actions", sortable: false },

    ],
    employees: [],
    editedIndex: -1,
    editedItem: {},
    apiPath: "employs",
    categories: [],
    suppliers: [], uniqueKey: 0, keyStock: 3,
    menuItems: [], langDate: "es", dataReady: false,
    dates: [],
    dateInit: null,
    dateEnd: null,
    kitId: 0,
    getKitView: false,
    keyView: 11,
    cloneKitId: 0,
    getKitClone: false,
    keyClone: 12,
    clone: false,
  }),
  mounted() {

  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Empleado" : "Editar Empleado";
    },
  },

  watch: {

  },

  created() {
    this.initialize();
  },

  methods: {
    async recibeTickect(item) {
      this.crateEditVer = false;
      if (!item) {
        this.close();
        return
      }
      item = await this.completeAndValidateItem(item)
      if (!item.id) {
        axios.post(api.api + "/products", item)
          .then(response => {
            const agregateProduct = this.agregateComplements(response.data);
            console.log("agregamos", agregateProduct)
            this.tickets.push(agregateProduct);
          })
      } else {
        axios.patch(`${api.api}/products/${item.id}`, item)
          .then(response => {
            item = this.agregateComplements(item);
            Object.assign(this.tickets[this.editedIndex], item)
          })
      }

    },

    agregateComplements(itemProduct) {
      const category = this.categories.find(cat => cat.value === itemProduct.categoryId)
      itemProduct.category = { name: category.text, id: category.value }
      const supplier = this.suppliers.find(sup => sup.value === itemProduct.supplierId)
      itemProduct.supplier = { name: supplier.text, id: supplier.value }
      return itemProduct
    },

    viewDialog() {
      // this.crateEditVer = true;
      // this.disabledForm = false;
      // this.dataForm = {};
      this.gestRequest = true;
    },

    async viewRequest() {
      if (this.products.length === 0) {
        axios
          .get(api.api + "/products")
          .then(r => {
            r.data.forEach(product => {
              this.products.push({
                text: `${product.name} - ${product.description}`,
                value: product.id
              });
            })
            this.gestRequest = true;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.gestRequest = true;
      }

    },

    async initialize() {
      const kits = await getKitsCache();
      this.movements = kits.map(kit => ({
        id: kit.id,
        ref: kit.ref,
        costCenter: kit.costCenter,
        zone: kit.zone.name,
        active: kit.active,
        positions: kit.items.map(item => item.position).filter((value, index, self) => self.indexOf(value) === index).join(' - '),
      }));

      console.log("kits", this.movements, kits)
    },

    viewItem(item) {
      this.kitId = item.id;
      this.keyView++;
      this.getKitView = true;
    },

    editItem(item) {
      this.kitId = item.id;
      this.keyStock++;
      this.gestRequest = true;
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.tickets[this.editedIndex], this.editedItem);
      } else {
        this.tickets.push(this.editedItem);
      }
      this.close();
    },

    async saveStock(stock) {
      if (this.kitId > 0) {
        console.log("editamos", this.kitId, stock)
        clientHttp.patch(`/kits/${this.kitId}`, stock).then(response => {
          console.log("editamos", response)
        }).catch(error => {
          console.log(error)
        })
      } else {
        const { data } = await saveKits(stock);
        const newKit = {
          id: data.id,
          ref: data.ref,
          costCenter: data.costCenter,
          active: data.active,
          zone: data.zone.name,
          positions: stock.items.map(item => item.position).filter((value, index, self) => self.indexOf(value) === index).join(' - ')
        }
        console.log("newKit", newKit, data)
        this.movements.push(newKit)
      }
      this.closeModal()
    },

    closeModal() {
      this.keyStock++;
      this.gestRequest = false;
      this.getKitView = false;
      this.getKitClone = false;
      this.keyView++;
      this.keyClone++;
      this.kitId = 0;
      this.clone = false;
      this.cloneKitId = 0;
    },

    cloneKit(kitId) {
      this.closeModal();
      this.cloneKitId = kitId;
      this.clone = true;
      this.getKitClone = true;
    },

    async deleteItem(item) {
      swal({ text: "Se eliminará el registro, ¿Desea continuar?", icon: "info", buttons: ["Cancelar", "Continuar"], })
        .then(async () => {
          await clientHttp.delete(`/kits/${item.id}`)
          this.movements = this.movements.filter(mov => mov.id !== item.id)
        })
    },

  },
};
</script>

<style lang="scss">
.topbar-logo {
  max-width: 150px;
}

.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}

.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}

.v-text-field__details {
  display: none;
}

.custom-font {
  font-family: 'Your Font Family', sans-serif;
  font-size: 16px;
  /* ajusta el tamaño de la fuente según tus necesidades */
  text-transform: uppercase;
}

.header {
  font-family: Arial, sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f0f0f0;
  border-bottom: 1px solid #ccc;
}

.column {
  flex: 1;
}

.logo {
  text-align: left;
}

.title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date-time {
  text-align: right;
}
</style>
